export default "__VITE_ASSET__5a4b9073__"